var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Label } from './Label';
export var FormInput = function (_a) {
    var label = _a.label, name = _a.name, register = _a.register, _b = _a.required, required = _b === void 0 ? false : _b, _c = _a.type, type = _c === void 0 ? 'text' : _c, error = _a.error, tooltip = _a.tooltip, placeholder = _a.placeholder;
    return (_jsxs("div", { children: [_jsxs(Label, { htmlFor: name, tooltip: tooltip, children: [label, " ", required && _jsx("span", { className: 'vas-text-vasDanger', children: "*" })] }), _jsx("input", __assign({ id: name, type: type, placeholder: placeholder }, register(name, {
                required: required &&
                    "".concat(name === null || name === void 0 ? void 0 : name.split('.')[(name === null || name === void 0 ? void 0 : name.split('.').length) - 1][0].toUpperCase()).concat(name === null || name === void 0 ? void 0 : name.split('.')[(name === null || name === void 0 ? void 0 : name.split('.').length) - 1].slice(1), " is required"),
            }), { className: "\n        !vas-w-full \n        !vas-p-2 \n        !vas-border \n        !vas-rounded-md\n        focus:!vas-border-primary\n        focus:!vas-outline-none\n      " })), error && (_jsx("span", { className: 'vas-text-vasDanger vas-text-vastypographyLabelsFontSize', children: error.message }))] }));
};
